"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6177],{

/***/ 56177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64384);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4557);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55150);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10411);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68866);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19521);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18682);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 10px;\n  row-gap: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  border: 2px solid #3bb77e;\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 10px;\n  color: #7e7e7e;\n  cursor: pointer;\n  :hover {\n    background-color: #3bb77e;\n  }\n  grid-column: span 1 / span 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  border: 2px solid #3bb77e;\n  background-color: #3bb77e;\n  border-radius: 5px;\n  padding: 10px;\n  color: #fff;\n  cursor: pointer;\n  :hover {\n    background-color: #3bb77e;\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        '\n  display: inline-block;\n  position: relative;\n  background-color: #fd7e14;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 5px;\n  line-height: 1.2;\n  word-break: keep-all;\n  text-align: center;\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: -15px;\n    left: 50%;\n    transform: translateX(-50%);\n    border-width: 8px;\n    border-style: solid;\n    border-color: transparent transparent #fd7e14 transparent;\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .close {\n    font-size: 16px;\n    color: #696969;\n    border: 2px solid #696969;\n    border-radius: 50%;\n    padding: 5px;\n    :hover {\n      color: #3bb77e;\n      border: 2px solid #3bb77e;\n    }\n  }\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    border-radius: 20px;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    height: 100%;\n    & h5 {\n      font-size: 18px;\n    }\n\n    & a {\n      width: 200px;\n    }\n  }\n\n  .close_icon {\n    cursor: pointer;\n    width: 30px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var BtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5b5da84-0"
})(_templateObject());
var PopupCheckoutBtn = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5b5da84-1"
})(_templateObject1());
var PopupRegisterBtn = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-b5b5da84-2"
})(_templateObject2());
var RegisterEventTooltip = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5b5da84-3"
})(_templateObject3());
var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5b5da84-4"
})(_templateObject4());
var RequestLoginModal = function(param) {
    var handleLoginModal = param.handleLoginModal, openLoginModal = param.openLoginModal, _$showToastAlert = param.showToastAlert, cartItems = param.cartItems, _$clearCart = param.clearCart, purchaseDirect = param.purchaseDirect, product = param.product, cnt = param.cnt, carbon = param.carbon, onClickLogin = param.onClickLogin;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return handleLoginModal();
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isUidRemembered = ref[0], setIsUidRemembered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        uid: "",
        upass: ""
    }), inputValues = ref1[0], setInputValues = ref1[1];
    // 정보 입력 상태 관리
    var inputHandler = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setInputValues(_objectSpread({}, inputValues, _defineProperty({}, name, value)));
    };
    // 아이디 토큰 확인
    var findUidCookie = function() {
        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("uid") === undefined) {
            return;
        } else if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("uid") !== undefined) {
            setInputValues({
                uid: (0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("uid")
            });
            return setIsUidRemembered(true);
        }
    };
    // 아이디 기억하기 체크 유무
    var rememberUidHandler = function() {
        setIsUidRemembered(!isUidRemembered);
    };
    // 로그인폼 제출
    var submitHandler = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var body, response, body1, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (inputValues.uid) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$showToastAlert("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694!", _common_alert__WEBPACK_IMPORTED_MODULE_7__/* .failToSubmit */ .PF));
                    case 5:
                        if (inputValues.upass) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", _$showToastAlert("\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694!", _common_alert__WEBPACK_IMPORTED_MODULE_7__/* .failToSubmit */ .PF));
                    case 7:
                        body = {
                            modes: "Login",
                            uid: inputValues.uid,
                            upass: inputValues.upass
                        };
                        _ctx.next = 10;
                        return (0,_api_login__WEBPACK_IMPORTED_MODULE_8__/* .submitLoginForm */ .X)(body, isUidRemembered);
                    case 10:
                        response = _ctx.sent;
                        if (!(response === "Success")) {
                            _ctx.next = 28;
                            break;
                        }
                        _$showToastAlert("\uD658\uC601\uD569\uB2C8\uB2E4!", _common_alert__WEBPACK_IMPORTED_MODULE_7__/* .succeedToSubmit */ .VJ);
                        if (!onClickLogin) {
                            _ctx.next = 16;
                            break;
                        }
                        onClickLogin();
                        return _ctx.abrupt("return");
                    case 16:
                        if (!((cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0)) {
                            _ctx.next = 22;
                            break;
                        }
                        body1 = {
                            modes: "InsertSet",
                            items: JSON.stringify(cartItems)
                        };
                        _ctx.next = 20;
                        return (0,_api_baskets__WEBPACK_IMPORTED_MODULE_10__/* .insertBaskets */ .nh)(body1);
                    case 20:
                        res = _ctx.sent;
                        _$clearCart();
                    case 22:
                        handleLoginModal();
                        sessionStorage.setItem("directOrder", JSON.stringify([
                            _objectSpread({}, product, {
                                cnt: cnt
                            })
                        ]));
                        router.push({
                            pathname: "/checkout",
                            query: {
                                type: "direct"
                            }
                        });
                        return _ctx.abrupt("return");
                    case 28:
                        return _ctx.abrupt("return", _$showToastAlert(response, _common_alert__WEBPACK_IMPORTED_MODULE_7__/* .failToSubmit */ .PF));
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        findUidCookie();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "col-lg-12 col-12 m-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "login_wrap widget-taber-content background-white",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "padding_eight_all bg-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "heading_s1 ",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "d-flex align-items-center justify-content-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                                            className: "mb-5",
                                                            children: "\uB85C\uADF8\uC778 "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                            src: "/assets/imgs/page/common/modal_close_icon.png",
                                                            alt: "modal_close_icon",
                                                            onClick: onClickLogin ? onClickLogin : handleLoginModal,
                                                            className: "close_icon"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "mb-20 mt-10",
                                                    style: {
                                                        wordBreak: "keep-all"
                                                    },
                                                    children: "\uB85C\uADF8\uC778\uD558\uC5EC \uAD6C\uB9E4\uD558\uC2DC\uBA74 \uD3EC\uC778\uD2B8 \uC801\uB9BD 1% \uBC0F \uCFE0\uD3F0 \uC0AC\uC6A9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                            onSubmit: submitHandler,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "form-group",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        name: "uid",
                                                        type: "text",
                                                        required: "",
                                                        placeholder: "\uC544\uC774\uB514",
                                                        defaultValue: inputValues.uid,
                                                        onChange: inputHandler,
                                                        className: "form-input"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "form-group",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        name: "upass",
                                                        type: "password",
                                                        required: "",
                                                        placeholder: "\uBE44\uBC00\uBC88\uD638",
                                                        onChange: inputHandler,
                                                        className: "form-input"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "login_footer form-group mb-10",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "chek-form ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "custome-checkbox",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                    className: "form-check-input",
                                                                    type: "checkbox",
                                                                    name: "checkbox",
                                                                    id: "exampleCheckbox1",
                                                                    value: "",
                                                                    checked: isUidRemembered,
                                                                    onChange: rememberUidHandler
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                                    className: "form-check-label",
                                                                    htmlFor: "exampleCheckbox1",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                        children: "\uC544\uC774\uB514 \uAE30\uC5B5\uD558\uAE30"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "form-group",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                        type: "submit",
                                                        className: "btn btn-heading col-12",
                                                        name: "login",
                                                        children: "\uB85C\uADF8\uC778"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !carbon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BtnWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PopupCheckoutBtn, {
                                            className: "btn btn-heading btn-block",
                                            onClick: purchaseDirect(product),
                                            children: "\uBE44\uD68C\uC6D0 \uAD6C\uB9E4\uD558\uAE30"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PopupRegisterBtn, {
                                            className: "btn btn-heading btn-block",
                                            onClick: function() {
                                                router.push("/register");
                                            },
                                            children: "\uD68C\uC6D0\uAC00\uC785"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RegisterEventTooltip, {
                                            children: "\uC9C0\uAE08 \uAC00\uC785\uD558\uACE0, \uCD5C\uB300 5\uB9CC\uC6D0 \uC6F0\uCEF4 \uCFE0\uD3F0\uD329 \uBC1B\uC73C\uC138\uC694!"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart
    };
};
var mapDispatchToProps = {
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_6__/* .showToastAlert */ .I,
    clearCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_12__/* .clearCart */ .LL
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(RequestLoginModal));


/***/ })

}]);